import ProfileController from './profileController';

export default ProfileController;
